import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { RESEARCH_SUPPORT_BASE } from '../../constants/researchSupport';

const faqs = [
  {
    q: 'What is the Undergraduate Research Publication Support Initiative?',
    a: 'It is an IO Fellowship program that helps undergraduate students and recent graduates prepare research for publication through structured submission, review, and editorial support.',
  },
  {
    q: 'Do I need an account to apply?',
    a: 'Yes. Create a free IO Fellowship account to submit, save drafts, and track your application status.',
  },
  {
    q: 'Can I submit more than one project?',
    a: 'Each distinct research title may be submitted once. If you need to correct a submission, contact support or respond to a revision request.',
  },
  {
    q: 'What happens after I submit?',
    a: 'You receive a confirmation email. Your submission moves to review, and you can monitor status updates in My Submissions.',
  },
  {
    q: 'Is there a fee?',
    a: 'The initiative is designed to support students accessibly. Any program-specific fees will be communicated clearly before you commit.',
  },
  {
    q: 'How long does review take?',
    a: 'Initial review typically begins within 3–5 business days. Full review may take 2–4 weeks depending on reviewer availability.',
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="space-y-6">
      <p className="text-gray-600">
        Questions about eligibility or documents? See{' '}
        <Link to={`${RESEARCH_SUPPORT_BASE}/guidelines`} className="text-iof font-medium hover:underline">
          Submission Guidelines
        </Link>
        .
      </p>

      <div className="space-y-3">
        {faqs.map((item, index) => (
          <div
            key={item.q}
            className="border border-gray-200 rounded-lg overflow-hidden bg-white"
          >
            <button
              type="button"
              className="w-full text-left px-5 py-4 flex justify-between items-center gap-4 hover:bg-gray-50"
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              aria-expanded={openIndex === index}
            >
              <span className="font-medium text-gray-900">{item.q}</span>
              <span className="text-iof text-xl shrink-0" aria-hidden="true">
                {openIndex === index ? '−' : '+'}
              </span>
            </button>
            {openIndex === index && (
              <div className="px-5 pb-4 text-gray-600 text-sm leading-relaxed border-t border-gray-100 pt-3">
                {item.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
